import tooltipDirective from "./Tooltip/";

const directives = (app) => {
    tooltipDirective(app);
};

export default directives;
